import APIClient from '@/shared/http/clients/api'

const resourceName = 'EquipamentoProntecaoIndividual'
const APIBusinessCommon = process.env.APIBaseURLBusinessCommon

const GetEPI = (apr, revisao, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/GetEpi/${apr}/${revisao}`, data, config)

const EpiRepository = {
  GetEPI
}

export default EpiRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/business/epi.js